/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Token/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Token({
  children,
  viewPath = "/App/Auth/SignIn/TwoFactorAuth/Token",
  isInvalid,
  onChange
  
}) {
let signinMfaTokenValueData = fromData.useDataValue({ viewPath,
context: 'signin',
path: 'mfa.token',
})
let signinMfaTokenIsValidData = fromData.useDataIsValid({ viewPath,
context: 'signin',
path: 'mfa.token',
validate: fromValidate.sixDigits,
required: true,
})
let signinMfaTokenChangeData = fromData.useDataChange({ viewPath,
context: 'signin',
path: 'mfa.token',
})
let onSubmit = fromHelpers.useOnSubmit({
  children,
  viewPath,
  isInvalid,
  onChange
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="text"
 data="signin.mfa.token"
 validate="/Data/validate.js sixDigits"
 required={true}
 invalid={!signinMfaTokenIsValidData}
 value={signinMfaTokenValueData}
 onChange={signinMfaTokenChangeData}
 onSubmit={onSubmit}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Two-factor authentication token"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 autoFocus={true}
 mask="sixDigits"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}